import React, {ReactElement} from 'react';
import {Typography} from '@mui/material';
import {CampaignAttributes} from 'models/storeDetails';
import OrderStatusBar from '.';
import './index.scss';

type GroupProgressBarProps = {
  primaryCampaign: CampaignAttributes;
  children?: JSX.Element | JSX.Element[];
};

const progressBarPercentage = (
  totalQuantity: number,
  expectedQuantity: number
): number => {
  if (!totalQuantity || !expectedQuantity) return 0;

  const progressPercent = (totalQuantity / expectedQuantity) * 100;
  return Math.min(progressPercent, 100);
};

const GroupProgressBar: React.FC<GroupProgressBarProps> = ({
  primaryCampaign,
  children
}: GroupProgressBarProps): ReactElement => {
  const totalQuantity = primaryCampaign?.totalItemsQuantity;
  const expectedQuantity = primaryCampaign?.expectedQuantity;

  return primaryCampaign ? (
    <div className="tracker-progressBar">
      <OrderStatusBar
        percentage={progressBarPercentage(totalQuantity, expectedQuantity)}>
        {/* PENDING: Remove fontSize prop override with Pigment update */}
        <Typography variant="captionSmall" fontSize={14}>
          {totalQuantity} ordered{' '}
          <span className="goalAmount">{`/ ${expectedQuantity} goal`}</span>
        </Typography>
      </OrderStatusBar>
      <div className="content">{children}</div>
    </div>
  ) : null;
};

GroupProgressBar.defaultProps = {
  children: undefined
};

export default GroupProgressBar;
